'use strict';

var m = angular.module('ui.utils.masks.ch', [])
	.directive('uiChPhoneNumberMask', require('./phone/ch-phone'));

module.exports = m.name;



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-input-masks/src/ch/ch-masks.js
 ** module id = 319
 ** module chunks = 1
 **/